export default {
  methods: {
    centsToDollars: function($value) {
      return $value / 100
    },
    centsToDollarsDisplay: function($value) {
      let negativeNumber = false
      if ($value < 0) {
        negativeNumber = true
        $value = $value * -1
      }

      return (negativeNumber ? '-' : '') + '$' + $value / 100
    },
    centsToDollarsAddGST: function($value) {
      return this.centsToDollars($value * 1.1)
    },
    getGSTFromCents: function($value, $hasGst) {
      if ($hasGst === true) {
        $value = $value / 1.1
      }
      return this.centsToDollars($value * 0.1)
    },
    removeGSTFromCents: function($value) {
      return this.centsToDollars($value / 1.1)
    },
    dollarsToCents: function($value) {
      return Math.round(($value * 100 + Number.EPSILON) * 100) / 100
    },
    multiplyCost: function($value, $multiplier) {
      return this.centsToDollars(this.dollarsToCents($value) * $multiplier)
    }
  }
}
